import { render, staticRenderFns } from "./SearchSort.vue?vue&type=template&id=2632b097&"
import script from "./SearchSort.vue?vue&type=script&lang=js&"
export * from "./SearchSort.vue?vue&type=script&lang=js&"
import style0 from "./SearchSort.vue?vue&type=style&index=0&id=2632b097&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports